import * as React from "react"

import {DATE_PERIODS} from "@constants"
import {DateRangeBlock} from "@components";
import {rangeDatesPricingMarketSku} from "../Ranges";
import {marketAnalyzerEvolutionSkuCurrentPeriod} from "../../../@signals";


export default function PricingSkuEvolutionDateSelect({dateRange, onChange}) {

    return <DateRangeBlock
        currentPeriodLabel={marketAnalyzerEvolutionSkuCurrentPeriod.value}
        maxDays={90}
        value={dateRange}
        ranges={rangeDatesPricingMarketSku}
        onChange={onChange}
        onOk = { () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.CUSTOM }
    />
}